export const invalidName = (name: string): boolean => {
  return !name.length;
};
